import { useTranslations } from '@npco/utils-translations'
import {
  ButtonGhost,
  ButtonGhostIconOnly,
  useIsMobileResolution,
} from '@npco/zeller-design-system'
import { useFeatureFlags } from 'features/FeatureFlags'

import { ReactComponent as CogIcon } from 'assets/svg/cogwheel.svg'

import { useGoToOutstandingTransactionsComingSoon } from '../../../../../../OutstandingTransactionsComingSoon/outstanding-transactions-coming-soon-routing/hooks/useGoToOutstandingTransactionsComingSoon/useGoToOutstandingTransactionsComingSoon'
import { useNavigateToCardSettings } from '../../../../../hooks/useNavigateToCardSettings/useNavigateToCardSettings'
import { corporateSettingButtonTranslations } from './CorporateSettingButton.i18n'

export const CorporateSettingButton = () => {
  const t = useTranslations(corporateSettingButtonTranslations)
  const { navigateToCardSettings } = useNavigateToCardSettings()
  const isMobile = useIsMobileResolution()
  const flags = useFeatureFlags()
  const { goToOutstandingTransactionsComingSoon } =
    useGoToOutstandingTransactionsComingSoon()

  const handleNavigationToCardSettings = () => {
    if (flags.CorpCardsSettings) {
      navigateToCardSettings()
    } else {
      goToOutstandingTransactionsComingSoon({ displayModal: true })
    }
  }

  if (isMobile) {
    return (
      <ButtonGhostIconOnly
        aria-label={t('settings')}
        icon={CogIcon}
        onClick={handleNavigationToCardSettings}
      />
    )
  }

  return (
    <ButtonGhost onClick={handleNavigationToCardSettings}>
      {t('settings')}
    </ButtonGhost>
  )
}
